import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_URL, PROXY_URL } from 'services/request';
import { PROVIDERS } from 'utilities/constants';

const { fetch: originalFetch } = window;

const fetchFn = async (...args) => {
  let [resource, config] = args;
  // proxy service doesn't accept request headers
  if (resource.url?.includes(PROXY_URL)) {
    resource.headers.delete('content-type')
  }
  const response = await originalFetch(resource, config);
  return response;
};

export const filesApi = createApi({
  reducerPath: 'filesApi',
  baseQuery: fetchBaseQuery({ baseUrl: API_URL, fetchFn }),
  endpoints: builder => ({
    createFile: builder.mutation({
      query: ({ projectName, bucketName = 'default', fileName, body, token }) => ({
        url: `/projects/${projectName}/buckets/${bucketName}/files/${fileName}`,
        headers: { Authorization: `${token}` },
        method: 'POST',
        body,
      }),
    }),
    downloadFile: builder.mutation({
      query: ({ projectName, bucketName = 'default', fileName, token }) => ({
        url: `${API_URL}/projects/${projectName}/buckets/${bucketName}/files/${fileName}/download`,
        method: 'GET',
        headers: { Authorization: `${token}` },
      })
    }),
    deleteFile: builder.mutation({
      query: ({ projectName, bucketName = 'default', fileName, token }) => ({
        url: `${API_URL}/projects/${projectName}/buckets/${bucketName}/files/${fileName}`,
        method: 'DELETE',
        headers: { Authorization: `${token}` },
      })
    }),
    getFile: builder.query({
      query: ({ projectName, bucketName = 'default', fileName, token }) => ({
        url: `/projects/${projectName}/buckets/${bucketName}/files/${fileName}`,
        headers: { Authorization: `${token}` },
      }),
    })
  }),
});

export const {
  useCreateFileMutation,
  useDownloadFileMutation,
  useDeleteFileMutation,
  useLazyGetFileQuery
} = filesApi;

export const uploadFile = (url, file, provider, onProgress) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
    };

    xhr.onload = () =>
      xhr.status < 300 ? resolve() : reject(new Error(xhr.responseText));

    xhr.onerror = () => reject(new Error('Upload failed'));

    xhr.open('PUT', url);

    if (provider === PROVIDERS.azure) {
      xhr.setRequestHeader("x-ms-version", "2020-04-08");
      xhr.setRequestHeader("x-ms-blob-type", "BlockBlob");
    }

    xhr.send(file);
  });
